import fastDeepEqual from 'fast-deep-equal/es6';

export class Utils {
  private constructor() {}

  public static isDeepEqual(a: any, b: any): boolean {
    return fastDeepEqual(a, b);
  }

  /**
   * A function which doesn't to anything. Useful if callbacks are required somewhere or to trick typescript/eslint that a variable is necessary etc
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static noop(..._args: Array<any>): void {}
}
